const ns = "ACCOUNTS_ASSIGNED_DOCUMENT_REQUESTS";
export const REQUEST = `${ns}_REQUEST`;
export const RECEIVE = `${ns}_RECEIVE`;
